/**
 * icons.jsx — inline SVG icons for the ClientWave360 landing page.
 * Ported from the redesign prototype. Icons use currentColor so they inherit
 * the scoped palette set in CSS.
 */

export const PhoneIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <path
      fill="currentColor"
      d="M3.7 1.3a1 1 0 0 1 1.4.1l1.8 2.2a1 1 0 0 1-.1 1.4l-.9.8a.6.6 0 0 0-.1.7 9.4 9.4 0 0 0 3.7 3.7c.2.1.5.1.7-.1l.8-.9a1 1 0 0 1 1.4-.1l2.2 1.8a1 1 0 0 1 .1 1.4l-1 1.2c-.5.5-1.2.8-1.9.6C8.6 13 3 7.4 1.9 2.2c-.2-.7.1-1.4.6-1.9l1.2 1z"
    />
  </svg>
);

export const MailIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      d="M1.8 4.2A1.4 1.4 0 0 1 3.2 2.8h9.6a1.4 1.4 0 0 1 1.4 1.4v7.6a1.4 1.4 0 0 1-1.4 1.4H3.2a1.4 1.4 0 0 1-1.4-1.4V4.2Zm.4.4L8 9l5.8-4.4"
    />
  </svg>
);

export const PinIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      d="M13 6.5c0 3.5-5 7.5-5 7.5S3 10 3 6.5a5 5 0 0 1 10 0Z"
    />
    <circle cx="8" cy="6.5" r="1.8" fill="none" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

export const CheckIcon = ({ size = 22 }) => (
  <svg viewBox="0 0 20 20" width={size} height={size} aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 10.5l4 4 8-9"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
    <path
      fill="currentColor"
      d="M13.4 21v-8.2h2.8l.4-3.2h-3.2V7.6c0-.9.3-1.6 1.6-1.6h1.7V3.1c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.3H7.2v3.2H10V21h3.4Z"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 4.6c2.4 0 2.7 0 3.7.1 2.4.1 3.5 1.2 3.6 3.6 0 1 .1 1.2.1 3.7 0 2.4 0 2.7-.1 3.7-.1 2.4-1.2 3.5-3.6 3.6-1 0-1.3.1-3.7.1s-2.7 0-3.7-.1c-2.4-.1-3.5-1.2-3.6-3.6 0-1-.1-1.3-.1-3.7s0-2.7.1-3.7c.1-2.4 1.2-3.5 3.6-3.6 1-.1 1.3-.1 3.7-.1ZM12 3c-2.4 0-2.8 0-3.7.1-3.3.1-5 1.9-5.2 5.1C3 9.2 3 9.6 3 12s0 2.8.1 3.7c.1 3.3 1.9 5 5.1 5.2 1 0 1.3.1 3.8.1s2.8 0 3.7-.1c3.3-.2 5-1.9 5.2-5.2 0-.9.1-1.3.1-3.7s0-2.8-.1-3.7c-.2-3.3-1.9-5-5.2-5.2C14.8 3 14.4 3 12 3Zm0 4.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm4.8-8.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Z"
    />
  </svg>
);

const LinkedinIcon = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
    <path
      fill="currentColor"
      d="M6.5 8.8H3.3V21h3.2V8.8ZM4.9 7.4a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM21 14.3c0-3.5-1.9-5.1-4.4-5.1-2 0-2.9 1.1-3.4 1.9V8.8H10V21h3.2v-6.5c0-1.7.8-2.7 2.2-2.7 1.4 0 2.1.9 2.1 2.7V21H21v-6.7Z"
    />
  </svg>
);

const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path
      fill="currentColor"
      d="M17.2 3h3l-6.6 7.6L21.5 21h-6.1l-4.8-6.3L5.1 21h-3l7.1-8.1L1.5 3h6.2l4.3 5.7L17.2 3Zm-1 16.2h1.7L6.8 4.7H5L16.1 19.2Z"
    />
  </svg>
);

const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path
      fill="currentColor"
      d="M21.6 7.2c-.2-1.3-1-2.1-2.3-2.3C17.6 4.6 12 4.6 12 4.6s-5.6 0-7.3.3C3.4 5.1 2.6 5.9 2.4 7.2 2.1 9 2.1 12 2.1 12s0 3 .3 4.8c.2 1.3 1 2.1 2.3 2.3 1.7.3 7.3.3 7.3.3s5.6 0 7.3-.3c1.3-.2 2.1-1 2.3-2.3.3-1.8.3-4.8.3-4.8s0-3-.3-4.8ZM10 15.2V8.8l5.5 3.2L10 15.2Z"
    />
  </svg>
);

export const CalendarIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      d="M2 5.5h12M4.8 1.8v2.4M11.2 1.8v2.4M3.4 3h9.2A1.4 1.4 0 0 1 14 4.4v8.2A1.4 1.4 0 0 1 12.6 14H3.4A1.4 1.4 0 0 1 2 12.6V4.4A1.4 1.4 0 0 1 3.4 3Z"
    />
  </svg>
);

export const GlobeIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <circle cx="8" cy="8" r="6.2" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      d="M1.8 8h12.4M8 1.8c1.7 1.6 2.6 3.8 2.6 6.2S9.7 12.6 8 14.2C6.3 12.6 5.4 10.4 5.4 8S6.3 3.4 8 1.8Z"
    />
  </svg>
);

/* ---------- Product & service icons (REQUEST-74 mockups) ---------- */

const productProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

/** Medicare Advantage — insurance card with a cross. */
const CardCrossIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <rect {...productProps} x="2.6" y="4.8" width="18.8" height="14.4" rx="2" />
    <path {...productProps} d="M2.6 8.2h18.8M2.6 11h18.8" />
    <path {...productProps} d="M5.8 14.4h5M5.8 17h3.4" />
    <path {...productProps} d="M16.5 13.4v4M14.5 15.4h4" />
  </svg>
);

/** Medicare Supplement — hands cradling a circled cross. */
const HandsCrossIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="12" cy="7.4" r="4.7" />
    <path {...productProps} d="M12 5.4v4M10 7.4h4" />
    <path
      {...productProps}
      d="M3.4 8.6c-.4 3.5.8 6.4 3.3 8.5 1 .9 2.1 1.6 3 2.5M20.6 8.6c.4 3.5-.8 6.4-3.3 8.5-1 .9-2.1 1.6-3 2.5"
    />
    <path {...productProps} d="M6.2 14.9c1.8-1.3 3.9-1.4 5.8-.2M17.8 14.9c-1.8-1.3-3.9-1.4-5.8-.2" />
  </svg>
);

/** Part D — Rx pill bottle with a capsule. */
const RxBottleIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path {...productProps} d="M7 3.2h10v3.2H7z" />
    <path {...productProps} d="M5.6 6.4h12.8v2.5H5.6z" />
    <path {...productProps} d="M6.6 8.9v9.5c0 .9.7 1.6 1.6 1.6h4.2M17.4 8.9v4.5" />
    <path {...productProps} d="M6.6 15.6h5" />
    <rect {...productProps} x="12.9" y="15.3" width="8" height="3.9" rx="1.95" transform="rotate(-28 16.9 17.25)" />
    <path {...productProps} d="M15.1 15.4l1.8 3.4" />
  </svg>
);

/** Dental — tooth. */
const ToothIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      {...productProps}
      d="M8 3.5c-2.6 0-4.4 2-4.4 4.7 0 4.4 2 7.3 2.8 11 .2 1 1.5 1.1 1.9.1l1.1-3.6c.4-1.2 2.8-1.2 3.2 0l1.1 3.6c.4 1 1.7.9 1.9-.1.8-3.7 2.8-6.6 2.8-11 0-2.7-1.8-4.7-4.4-4.7-1.5 0-2.4.8-4 .8s-2.5-.8-4-.8Z"
    />
  </svg>
);

/** Vision — eye with a solid pupil. */
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path {...productProps} d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
  </svg>
);

/** Hospital Indemnity — circled cross. */
const CircleCrossIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="12" cy="12" r="8.7" />
    <path {...productProps} d="M10.4 6.9h3.2v3.5h3.5v3.2h-3.5v3.5h-3.2v-3.5H6.9v-3.2h3.5z" />
  </svg>
);

/** Cancer — awareness ribbon. */
const RibbonIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      {...productProps}
      d="M12 3.2c-2 0-3.4 1.5-3.4 3.6 0 3.4 2.4 5.4 3.4 6.3 1-.9 3.4-2.9 3.4-6.3 0-2.1-1.4-3.6-3.4-3.6Z"
    />
    <path {...productProps} d="m9.4 10.6-3.6 9.2 4.2-2 2 2.7 2-2.7 4.2 2-3.6-9.2" />
  </svg>
);

/** Heart & Stroke — heart with a cross. */
const HeartCrossIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      {...productProps}
      d="M12 20.2S4.2 15.4 4.2 9.8A4.6 4.6 0 0 1 12 6.6a4.6 4.6 0 0 1 7.8 3.2c0 5.6-7.8 10.4-7.8 10.4Z"
    />
    <path {...productProps} d="M10.8 9.2h2.4v2.1h2.1v2.4h-2.1v2.1h-2.4v-2.1H8.7v-2.4h2.1z" />
  </svg>
);

/** Final Expense — hand holding a shield with a check. */
const ShieldHandIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path {...productProps} d="M12 2.4l4.7 1.8v3.3c0 3.1-2 5.6-4.7 6.6-2.7-1-4.7-3.5-4.7-6.6V4.2L12 2.4Z" />
    <path {...productProps} d="M9.9 7.2l1.6 1.6 2.8-3.1" />
    <path {...productProps} d="M3 16.6l2.8-2.4c.7-.6 1.5-.9 2.4-.9h4.5c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1H9.8" />
    <path {...productProps} d="M13.8 14.9l4.3-2.5c.6-.4 1.4-.2 1.8.4.4.6.2 1.4-.4 1.8l-4.7 3.5c-.6.4-1.3.7-2 .7H3" />
  </svg>
);

/** Life — person with a shield. */
const PersonShieldIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="10" cy="7.2" r="3.2" />
    <path {...productProps} d="M3.5 20c.6-3.6 3.2-5.6 6.5-5.6 1 0 1.9.2 2.7.5" />
    <path {...productProps} d="M17.5 12.5l3 1.1v2.2c0 2-1.3 3.5-3 4.2-1.7-.7-3-2.2-3-4.2v-2.2l3-1.1Z" />
  </svg>
);

/** Annuities — piggy bank with a coin. */
const PiggyIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="14.7" cy="4.7" r="2.4" />
    <path
      {...productProps}
      d="M9.8 7.6c.9-.3 1.8-.5 2.8-.5 3.9 0 7 2.6 7 5.9 0 1.9-1 3.6-2.6 4.7v2.6h-2.8l-.4-1.2a9.6 9.6 0 0 1-2.6 0l-.4 1.2H8v-2.6a6.3 6.3 0 0 1-2.2-2.6H3.6v-3.2h1.9A6.3 6.3 0 0 1 8 8.8"
    />
    <path {...productProps} d="M6.6 6.6l1.6 1.6" />
    <circle cx="8.9" cy="11.5" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

/** Long Term Care — person in a wheelchair with a clock. */
const WheelchairClockIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="9.4" cy="4.3" r="2" />
    <path {...productProps} d="M8.8 6.8c1 .3 1.7 1.2 1.8 2.3l.3 2.9h3.1c.7 0 1.3.4 1.6 1l.7 1.4" />
    <circle {...productProps} cx="8.4" cy="16.2" r="4.4" />
    <circle cx="8.4" cy="16.2" r="1" fill="currentColor" stroke="none" />
    <circle {...productProps} cx="17.7" cy="17.5" r="3.7" />
    <path {...productProps} d="M17.7 15.8v1.7l1.2.8" />
  </svg>
);

/** Short Term — stopwatch. */
const StopwatchIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <circle {...productProps} cx="12" cy="13.5" r="7.7" />
    <path {...productProps} d="M10.1 2.5h3.8M12 2.5v3.3M18.8 6.9l1.3 1.3" />
    <path {...productProps} d="M12 8.7v4.8" />
    <circle cx="12" cy="13.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

/** ACA — layered shield with a cross. */
const ShieldCrossIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path {...productProps} d="M12 2.4l7.6 2.7v5.6c0 4.7-3.2 8.4-7.6 10.1-4.4-1.7-7.6-5.4-7.6-10.1V5.1L12 2.4Z" />
    <path {...productProps} d="M10.6 7.6h2.8v2.5h2.5v2.8h-2.5v2.5h-2.8v-2.5H8.1v-2.8h2.5z" />
  </svg>
);

/**
 * Map a plan/product name to its grid icon. Matches loosely on keywords so
 * both the CF360 chip values and legacy `plans_offered` strings resolve.
 */
export function productIcon(plan) {
  const p = String(plan || '').toLowerCase();
  if (p.includes('advantage')) return CardCrossIcon;
  if (p.includes('supplement')) return HandsCrossIcon;
  if (p.includes('part d') || p.includes('prescription') || p.includes('drug')) return RxBottleIcon;
  if (p.includes('dental')) return ToothIcon;
  if (p.includes('vision')) return EyeIcon;
  if (p.includes('hospital')) return CircleCrossIcon;
  if (p.includes('cancer')) return RibbonIcon;
  if (p.includes('heart') || p.includes('stroke')) return HeartCrossIcon;
  if (p.includes('final expense')) return ShieldHandIcon;
  if (p.includes('life')) return PersonShieldIcon;
  if (p.includes('annuit')) return PiggyIcon;
  if (p.includes('long term') || p.includes('long-term')) return WheelchairClockIcon;
  if (p.includes('short term') || p.includes('short-term')) return StopwatchIcon;
  return ShieldCrossIcon;
}

/**
 * Social platforms in render order. `key` matches the profile field that holds
 * the URL; `label` is the accessible name.
 */
export const SOCIAL_PLATFORMS = [
  { key: 'facebook', label: 'Facebook', Icon: FacebookIcon },
  { key: 'instagram', label: 'Instagram', Icon: InstagramIcon },
  { key: 'linkedin', label: 'LinkedIn', Icon: LinkedinIcon },
  { key: 'twitter', label: 'X (Twitter)', Icon: TwitterIcon },
  { key: 'youtube', label: 'YouTube', Icon: YoutubeIcon }
];
